import styled from 'styled-components'

const BoardContainer = styled.div<{ showDataPicker?: boolean }>`
  width: 100%;
  gap: 5px;
  overflow-x: scroll;
  position: relative;
  z-index: ${({ showDataPicker }) => (showDataPicker ? '-1' : 'auto')};
  max-width: calc(100% - 20px);
  ::-webkit-scrollbar {
    height: 8px;
    background-color: #c4c4c4;
    border-radius: 100px;
  }
  ::-webkit-scrollbar-track {
    background: white;
    border: 0;
    margin-top: 8px;
  }
  ::-webkit-scrollbar-thumb {
    height: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
`

const ColumnList = styled.ol`
  max-height: 100%;
  display: flex;
  flex-direction: row;
  gap: 5px;
  flex-grow: 1;
  width: 100%;
`
export { BoardContainer, ColumnList }
